import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarHoverInventory(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);
    
    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="Inventory"?"":"Inventory")} title="Inventory" className={props.activeMenu == "Inventory" ? "sidenav-collapsed-active pointer px-0 sidenavbar-text":"pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("inventory:inventory:view")?false:true}>
                <span className="mx-2 sidenavbar-text">Inventory
                    <i className={showMenu=="Master"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "Inventory" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/inventory/containersummary")} title="Container Summary" 
                className={props.activeSubMenu == "ContainerSummary" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("inventory:container:view")?false:true}>
                    Container Summary
                </a>
            </ul>
            <ul className={showMenu == "Inventory" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => navigate("/inventory/container")} title="Container"
                className={props.activeSubMenu == "Container" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "text-theme-light-green pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("inventory:container:view")?false:true}>
                    Containers
                </a>
            </ul>
        </>
    );
}

export default SideNavBarHoverInventory;
